export class SetPrefix {
  public static readonly type = '[Environment] Set prefix';
  public constructor(public prefix: string) {}
}
